/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useState } from "react";
import ExamContent from "../components/IFRS/ExamContent";
import ExamInstructions from "../components/IFRS/ExamInstructions";
import { useParams } from "react-router-dom";
import { GetIFRSById } from "../api/Quiz/GetIFRSById";
import { useQuery } from "@tanstack/react-query";
import Spinner from "../components/Shared/Spinner";
const IFRSExam = () => {
    const { id } = useParams();
    const IFRSId = id || '';
    const [showInstructions, setShowInstructions] = useState(true);
    const { data, isLoading } = useQuery({
        queryKey: ["ifrs", IFRSId],
        queryFn: () => GetIFRSById(IFRSId),
    }); 
    console.log(data);
    if (isLoading) return <div className="flex justify-center items-center h-screen">
        <Spinner/>
    </div>;
    return (
        <div id="ifrs">
            {showInstructions ? (
                <ExamInstructions onNext={() => setShowInstructions(false)} />
            ) : (
                //@ts-expect-error
                <ExamContent data={data?.data} />
            )}
        </div>
    );
};

export default IFRSExam;
